import React from 'react';

import { useTranslation } from '@/presentation/hooks/useTranslation';
import {
  StoreImage,
  StoreImageButton,
  StorePageHeader,
  StorePageHeaderContainer,
  StoreTitleContainer,
  Title,
} from './style';
import useClickoutUrl, { RedirectSource } from '../../hooks/clickoutUrl';

export type StoreHeaderProps = {
  imageUrl: string;
  storeName: string;
  headerTitle?: string;
  loading?: boolean;
  currentUserId: string;
  storeId: string;
};

const StoreHeader = ({
  imageUrl,
  headerTitle,
  storeName,
  currentUserId,
  storeId,
}: StoreHeaderProps) => {
  const { t } = useTranslation('coupons');
  const { clickoutUrl } = useClickoutUrl(
    RedirectSource.Store,
    {
      storeId,
      userId: currentUserId,
    },
    currentUserId
  );

  const handleImageClick = (clickoutUrl: string) => {
    window.open(clickoutUrl, '_blank');
  };

  return (
    <StorePageHeaderContainer>
      <StorePageHeader className="maximumGrid">
        <StoreTitleContainer>
          <StoreImageButton
            type="button"
            onClick={() => handleImageClick(clickoutUrl || '')}
            aria-label={`${t('store-imade-button')} ${storeName}`}
          >
            <StoreImage
              id="store-image-header"
              src={imageUrl}
              alt={`${t('store-image-alt')} ${storeName}`}
              loading="eager"
              fetchPriority="high"
            />
          </StoreImageButton>
          <Title>{headerTitle}</Title>
        </StoreTitleContainer>
      </StorePageHeader>
    </StorePageHeaderContainer>
  );
};

export default StoreHeader;
